import React, { useState } from 'react';
import MuiPasswordInput from './fields/MuiPasswordInput';

const MuiViewablePassword = (props) => {
  const { name, label, errors, helperText, inputLabelProps, ...inputProps } =
    props;

  const [value, setValue] = useState('');

  const handleChange = (value) => {
    setValue(value);
  };

  return (
    <MuiPasswordInput
      name={name}
      value={value}
      onChange={handleChange}
      label={label}
      error={errors && Boolean(errors[0])}
      helperText={(errors && errors[0]) || helperText}
      {...inputProps}
      InputLabelProps={inputLabelProps}
    />
  );
};

export default MuiViewablePassword;
